import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { Loader } from '../state/models';
import { getById, State } from '../state/reducers';

@Component({
    selector: 'analytics-dialog-loader',
    templateUrl: './dialog-loader.component.html',
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AsyncPipe, TranslatePipe],
})
export class DialogLoaderComponent implements OnInit {
    @Input() loaderId: string;

    loader$: Observable<Loader>;

    constructor(private readonly store$: Store<State>) {}

    ngOnInit() {
        this.loader$ = this.store$.pipe(select(getById(this.loaderId)));
    }
}
